<footer class="app-footer">
  <ng-content></ng-content>
</footer>
